import { isSSR } from '../Utils/ssrUtils.js';

const shouldShowDebuggingInfo = (isDebugMode = false) => {
  if (isSSR()) {
    return false;
  }
  return /ricos-debug/i.test(window.location.search) || isDebugMode;
};

export { shouldShowDebuggingInfo };
//# sourceMappingURL=shouldShowDebuggingInfo.js.map
